module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/kitchen.json
// module id = 368
// module chunks = 34393763138769